import dispatchPage from './dispatch.vue';

const dispatch = {
    install: function(Vue) {
        Vue.component('dispatch', dispatchPage)
    }
}

export default dispatch;